import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
	TelegramNotifyMutationKeys,
	TelegramNotifyQueryKeys,
} from '../../../keys'
import { updateTelegramNotifySetting } from '../../services'

import type { UpdateTelegramNotifySettingDto } from '../../../types'

export default function useMutationUpdateTelegramNotifySetting() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationKey: [TelegramNotifyMutationKeys.UpdateTelegramNotifySetting],
		mutationFn: (payload: UpdateTelegramNotifySettingDto) =>
			updateTelegramNotifySetting(payload),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [TelegramNotifyQueryKeys.GetTelegramNotifySetting],
			})
		},
	})
}
